import BulletList from '@tiptap/extension-bullet-list';

// Stock BulletList binds Mod-Shift-8 to the raw toggleBulletList command,
// which bypasses this app's toggleBulletListSafely logic and conflicts with
// this app's Mod-Shift-8 = Numbered List mapping. KeyboardShortcuts
// (keyboard-shortcuts.ts) owns Mod-Shift-7/8/9 instead.
export const BulletListNoShortcut = BulletList.extend({
  addKeyboardShortcuts() {
    return {};
  },
});
